import {CircleNode, CircleNodeModel} from '@logicflow/core';

class NodeEndModel extends CircleNodeModel {
    getNodeStyle() {
        const style = super.getNodeStyle();
        const properties = this.properties;

        style.strokeWidth = 1
        if (properties.finish === true || properties.current === true) {
            style.strokeWidth = 3;
        }

        if (properties.skin_fill) {
            style.fill = properties.skin_fill;
        }

        if (properties.style_fill) {
            style.fill = properties.style_fill
        }

        if (properties.style_stroke) {
            style.stroke = properties.style_stroke
        }

        return style;
    }
}

export default {
    type: 'node_end',
    view: CircleNode,
    model: NodeEndModel,
};